export enum Race {
    Asian = 'Asian',
    Black = 'Black',
    Multiple = 'Multiple',
    NativeAmerican = 'NativeAmerican',
    NativePacificIsles = 'NativePacificIsles',
    Unknown = 'Unknown',
    White = 'White',
}
